import React from 'react';

import PropTypes from 'prop-types';

import { buildHrefLangLink, getHrefLangPairs } from '../../utils';

function HrefLangs(props) {
    const {
        supportedLocales,
        path,
        noIndexLocale,
    } = props;

    const hrefLangsPairs = getHrefLangPairs({
        noIndexLocale,
        supportedLocales,
    });

    return hrefLangsPairs.map(({ hrefLang, locale }) => (
        <link
            data-testid="href-lang-link"
            href={buildHrefLangLink({
                hrefLang,
                locale,
                path,
            })}
            hrefLang={hrefLang}
            key={hrefLang}
            rel="alternate"
        />
    ));
}

HrefLangs.propTypes = {
    path: PropTypes.string.isRequired,
    supportedLocales: PropTypes.array.isRequired,
};

export {
    HrefLangs,
};

export default HrefLangs;
